import tw from "twin.macro";
export const SectionDescription = tw.p`mt-4 text-gray-500 text-justify  text-sm md:text-base lg:text-lg font-light leading-relaxed mb-5`;
